<template>
  <!-- Bottom Navigation - Hidden on large screens where sidebar is visible -->
  <nav class="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-1 py-1 z-50">
    <div class="flex justify-around items-center max-w-lg mx-auto">
      <!-- Dashboard -->
      <router-link 
        to="/dashboard" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/dashboard') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
        </svg>
        <span>Home</span>
      </router-link>

      <!-- POS -->
      <router-link 
        to="/pos" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/pos') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11.707 4.707a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/>
        </svg>
        <span>POS</span>
      </router-link>

      <!-- Products -->
      <router-link 
        to="/products" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/products') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.5777 4.43152L15.5777 3.38197C13.8221 2.46066 12.9443 2 12 2C11.0557 2 10.1779 2.46066 8.42229 3.38197L8.10057 3.5508L17.0236 8.64967L21.0403 6.64132C20.3941 5.90949 19.3515 5.36234 17.5777 4.43152Z"/>
          <path d="M21.7484 7.96434L17.75 9.96353V13C17.75 13.4142 17.4142 13.75 17 13.75C16.5858 13.75 16.25 13.4142 16.25 13V10.7135L12.75 12.4635V21.904C13.4679 21.7252 14.2848 21.2965 15.5777 20.618L17.5777 19.5685C19.7294 18.4393 20.8052 17.8748 21.4026 16.8603C22 15.8458 22 14.5833 22 12.0585V11.9415C22 10.0489 22 8.86557 21.7484 7.96434Z"/>
          <path d="M11.25 21.904V12.4635L2.25164 7.96434C2 8.86557 2 10.0489 2 11.9415V12.0585C2 14.5833 2 15.8458 2.5974 16.8603C3.19479 17.8748 4.27062 18.4393 6.42228 19.5685L8.42229 20.618C9.71524 21.2965 10.5321 21.7252 11.25 21.904Z"/>
          <path d="M2.95969 6.64132L12 11.1615L15.4112 9.4559L6.52456 4.37785L6.42229 4.43152C4.64855 5.36234 3.6059 5.90949 2.95969 6.64132Z"/>
        </svg>
        <span>Products</span>
      </router-link>

      <!-- Sales History -->
      <router-link 
        to="/transactions" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/transactions') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"/>
          <path fill-rule="evenodd" d="M4 5a2 2 0 012-2v1a1 1 0 001 1h6a1 1 0 001-1V3a2 2 0 012 2v6a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3z" clip-rule="evenodd"/>
        </svg>
        <span>Sales</span>
      </router-link>

      <!-- Customers -->
      <router-link 
        to="/customers" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/customers') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 20 20">
          <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>
        </svg>
        <span>Customers</span>
      </router-link>

      <!-- Settings -->
      <router-link 
        to="/settings" 
        class="flex flex-col items-center p-1.5 text-xs transition-colors"
        :class="isActive('/settings') ? 'text-blue-600' : 'text-gray-500'"
      >
        <svg class="w-5 h-5 mb-1" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd"/>
        </svg>
        <span>Settings</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const isActive = (path) => {
  return route.path === path || (path === '/dashboard' && route.path === '/')
}
</script>
